import React from "react";

import Framework from "@beardeddevops/react.framework";
import Types from "constants/Types";

import {Button} from "reactstrap";
import Tooltip from "@material-ui/core/Tooltip";
import {Collections, Elements, Parts} from "components";
import TransactionObject from "components/TransactionObject";
import UniversalModalOverride from "components/UniversalModalOverride";


/**
 *  @property {Transactions_Collections_Object|Transactions_Collections_Is} state
 *  @property {object} model
 *  @property {Transactions_Collections_Properties} model.properties
 *  @property {Transactions_Collections_Is} model.is
 *  @property {Transactions_Collections_Has} model.has
 */
export default class DestroyObject extends TransactionObject {
	constructor(props) {
		super(props, Types.Transactions_Collections._name);
		this.read = 'GET_DESTROY';
		this.update = typeof props.id !== 'undefined' && props.id ? 'POST_DESTROY' : 'PUT_DESTROY';
		this.delete = 'DELETE_DESTROY';
	}

	/**
	 * @param prevProps
	 * @param {Transactions_Collections_Object} prevState
	 * @param snapshot
	 */
	componentDidUpdate(prevProps, prevState, snapshot) {
		super.componentDidUpdate(prevProps, prevState, snapshot);

		// noinspection JSValidateTypes
		/** @type {Transactions_Collections_Object} object */
		let object = this.state;

		//If Pkey has always been blank || this isn't the initial load so pkey is the same
		if (prevState.pkey === object.pkey || prevState.binary_id === object.binary_id) {
			//Then check related props
			if (object.dealer !== prevState.dealer) {
				this.setState({
					'dealer_name_company': object.dealer ? object.dealers.name_display || object.dealers.name_trade || object.dealers.name_company : '',
					'dealer_ffl': object.dealer ? object.dealers.ffl : ''
				});
			}
			if (prevState.location && object.location !== prevState.location) {
				this.setState({'bound_book': ''});
			}
		}
	}

	// noinspection JSUnusedGlobalSymbols
	/**
	 * @param {Transactions_Collections_Object} data
	 */
	loadSelfAfter(data) {
		if (typeof this.props.updateName === 'function') {
			this.props.updateName(data.transaction || (data.binary_id + '-' + data.pkey));
		}
	};

	async handleSubmit(event, suppressToast = false) {
		if (this.state.transaction_entriess) {
			this.state.products = this.state.transaction_entriess.map(entry => entry.products.binary_id + '-' + entry.products.pkey);
		}
		await super.handleSubmit(event, suppressToast);
	};

	form = () => {
		/** @type {Transactions_Collections_Properties} properties */
		let properties = this.model.properties;
		/** @type {Transactions_Collections_Object} object */
		let object = this.state;
		let {loading} = this.state;

		return (
			<div>
				<fieldset>
					<div className={"row"}>
						{/*#region Col 1*/}
						<div className={"col-md"}>
							{/*#region Details Section*/}
							<h4 className="section-title">Details</h4>
							<Parts.SelectLocation
								object={object}
								properties={properties}
								shouldLoad={this.state.loaded}
								onSelectUpdate={this.handleSelectPropertyUpdate}
								locations={this.props.locations}
								states={this.props.states}
								filter={this.filterLocationOptions}
							/>
							<div className={'form-group'}>
								<div className="row">
									<div className="col-4">
										<span className="input-label">Date</span>
									</div>
									<div className={'col-8'}>
										<div className="form-group">
											<Framework.Elements.DateTime
												property={properties.date}
												value={object.date}
												error={object.date_error}
												update={this.handleTextFieldPropertyUpdate}
											/>
										</div>
									</div>
								</div>
							</div>
							<div className="form-group">
								<Framework.Elements.TextField
									label={"Destroyed Item(s) Notes"}
									property={properties.notes}
									value={object.notes}
									error={object.notes_error}
									update={this.handleTextFieldPropertyUpdate}
									multiline={4}
								/>
							</div>
							{/*#endregion*/}
						</div>
						{/*#endregion*/}
						{/*#region Col 2*/}
						<div className={"col-md"}>
							{/*#region Items Section*/}
							<h4 className="section-title">
								Items
								<div className="pull-right">
									<Tooltip
										title="Products you have previously acquired and disposed / transferred can be found here."
										aria-label="Products you have previously acquired and disposed / transferred can be found here.">
										<Button onClick={this.handleToggleModalLookup} size={"sm"} color="primary" data-id={"quick-destroy-products"}>
											<i className={"fa fa-barcode"}/>
											<span className="hidden-xs">&nbsp;&nbsp;Items</span>
										</Button>
									</Tooltip>

									<UniversalModalOverride
										locations={this.props.locations}
										states={this.props.states}
										history={this.props.history}
										name={"In Stock Products"}
										object={Collections.ProductsExisting}
										toggle={this.state.modalLookup}
										reportClose={this.handleReportProductClose}
										afterSave={this.addProducts}
										size={"xl"}
										status={"GET_IN_STOCK"}
										objectProps={{scannedCode: this.props.scannedCode}}
									/>

								</div>
							</h4>

							{object.transaction_entriess && object.transaction_entriess.map(
								(entry, i) =>
									<Elements.Item
										key={i}
										entry={entry}
										product={entry.products}
										onDelete={this.deleteProduct}
										onUpdate={this.updateProduct}
										openModal={this.handleToggleProductModel('productUpdate' + i)}
										reportClose={this.handleReportModalClose('productUpdate' + i)}
										modalUpdate={this.state['productUpdate' + i]}
										locations={this.props.locations}
										states={this.props.states}
										history={this.props.history}
									/>
							)}

							<p style={{textAlign: 'center', color: 'grey'}}><i>{object.transaction_entriess.length} Total Items</i></p>
							{/*#endregion*/}
						</div>
						{/*#endregion*/}
					</div>
				</fieldset>

				<Framework.Elements.LoadingSpinner isLoading={loading}/>
			</div>
		)
	};

}
